<template>
  <div class="mask searchFilter" :class="{fixed:mask}">
    <div class="search"
      style="background-color:#ffffff;position:fixed">
      <div class="search-head">
        <form action="" style="width:100%;" class="flex between align">
          <input class="search-head-input" v-model="input" type="search" :placeholder="placeholder"
            @keyup.enter="onFilter" @focus="onBlur">
          <!-- <i class="fa fa-close clear" v-show="input" @click.stop="input = ''"></i> -->
          <img src="../assets/close.png" class="fa fa-close clear" v-show="input" @click.stop="input = ''">
          <span @click.stop="onFilter">
            <!-- <icon type="searchFilter" :sizeW="13" :sizeH="13" class="searchFilter-icon" /> -->
            <img src="../assets/search.svg" class="searchFilter-searchImg">
          </span>
        </form>

      </div>
     
    </div>

    <slot name="searchMore"></slot>

  </div>
</template>
<script>
  import {
    Toast
  } from 'mint-ui';
  export default {
    name: 'SearchFilter',
    props: {
      mask: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
      init: {
        type: String,
        default: '',
      }
    },
    data() {
      return {
        input:this.init,
        body: {
          keyword: '',
          pagination: {
            pageNo: 1,
            pageSize: 5
          }
        }
      }
    },
    methods: {
      onReset() {
        this.$emit('reset')
      },
      onClose() {
        this.$emit('close')
      },
      onFilter() {
        let inputVal = this.input.trim()
        if (inputVal == '') {
          Toast('请输入关键词')
          return
        }
        this.body.keyword = inputVal
        this.$emit('filter', this.body)
      },
      onBlur() {
        window.scroll(0, 0);
        // document.activeElement.blur()
      },
    },
  };

</script>
<style lang="stylus">
  @import '../stylus/components/search.styl'

</style>



// WEBPACK FOOTER //
// src/components/SearchFilter.vue